import * as _4 from 'lodash4';
import { APAdvisorText } from './../../servants/ap_advisor_text_servant';

export class CourseStatusBadge {
  type: string;
  showTitle: boolean;
  icon: string;
  isIcon: boolean;
  iconTheme: string;
  iconSize: string;
  styles: string;
  statusBadgeTheme: string;
  context: string;
  shape: string;
  title: string;
  toolTipMessage: string;
  isEditable: string | boolean;
  theme: string;

  badgeTypes: any;

  constructor(private phxFeatureConfiguration: any, private ngAPAdvisorText: APAdvisorText) {
    const advisorLabel = this.ngAPAdvisorText.advisorLabel;

    const noStyles = '';
    const defaultTheme = 'transparent';
    const shape = 'circle';

    this.badgeTypes = {
      devrequisite: {
        icon: 'book',
        isIcon: true,
        iconTheme: 'blue',
        iconSize: 'medium',
        styles: noStyles,
        theme: defaultTheme,
        context: 'Required Developmental Course',
        shape,
        title: 'Developmental Course',
        toolTipMessage: 'Required Developmental Courses'
      },
      flag: {
        icon: 'flag',
        isIcon: true,
        iconTheme: 'blue',
        iconSize: 'medium',
        styles: noStyles,
        theme: defaultTheme,
        context: `Course flagged by ${advisorLabel}`,
        shape,
        title: `Course flagged by ${advisorLabel}`,
        toolTipMessage: `Course flagged by ${advisorLabel}, check comments for more info`
      },
      lock: {
        icon: 'lock',
        isIcon: true,
        iconTheme: 'blue',
        iconSize: 'medium',
        styles: noStyles,
        theme: defaultTheme,
        context: `Course locked by ${advisorLabel}`,
        shape,
        title: `Course locked by ${advisorLabel}`,
        toolTipMessage: `${_4.upperFirst(advisorLabel)} locked this course. You cannot move/remove course from term`
      }
    };
  }
  intialize() {
    this.type = _4.toLower(this.type);
    this.showTitle = !!this.showTitle;
    this.icon = this.badgeTypes[this.type].icon;
    this.isIcon = this.badgeTypes[this.type].isIcon;
    this.iconTheme = this.badgeTypes[this.type].iconTheme;
    this.iconSize = this.badgeTypes[this.type].iconSize;
    this.styles = this.badgeTypes[this.type].styles;
    this.statusBadgeTheme = this.theme || this.badgeTypes[this.type].theme;
    this.context = this.badgeTypes[this.type].context;
    this.shape = this.badgeTypes[this.type].shape;
    this.title = this.badgeTypes[this.type].title;
    this.toolTipMessage = this.badgeTypes[this.type].toolTipMessage;
    this.isEditable = _4.isBoolean(this.isEditable) ? this.isEditable : this.isEditable === 'true';
  }
  $onInit() {
    this.intialize();
  }
  $onChanges() {
    this.intialize();
  }
  getValue(value: string) {
    return value;
  }
}

angular.module('capability-ng-academic-planner').component('courseBadge', {
  templateUrl: 'capability-ng-academic-planner/src/global/components/course_status_badge/course_status_badge.html',
  bindings: {
    type: '@',
    showTitle: '<',
    isEditable: '<?',
    theme: '<?'
  },
  controller: CourseStatusBadge
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_status_badge/course_status_badge.ts